module.exports = __webpack_public_path__ + "img/two-red-fire.cd9fea2e.svg";